import {
  StudentOrTeacherChatInsertUsersDocument,
  StudentOrTeacherChatInsertUsersMutation,
  StudentOrTeacherChatInsertUsersMutationVariables,
  StudentOrTeacherTogglePinMessageMutationVariables,
  StudentOrTeacherTogglePinMessageMutation,
  StudentOrTeacherTogglePinMessageDocument,
} from '../types';
import { client } from '../../client';

// teacherConversationParticipantMutation
export async function studentOrTeacherAddChatUsers(variables: StudentOrTeacherChatInsertUsersMutationVariables): Promise<Readonly<number>> {
  try {
    const result = await client.mutate<StudentOrTeacherChatInsertUsersMutation, StudentOrTeacherChatInsertUsersMutationVariables>({
      mutation: StudentOrTeacherChatInsertUsersDocument,
      variables,
    });
    return result.data.insert_chat_user.affected_rows;
  } catch (error) {
    throw Error(error);
  }
}

export async function togglePinMessage(variables: StudentOrTeacherTogglePinMessageMutationVariables): Promise<Readonly<any>> {
  try {
    const result = await client.mutate<StudentOrTeacherTogglePinMessageMutation, StudentOrTeacherTogglePinMessageMutationVariables>({
      mutation: StudentOrTeacherTogglePinMessageDocument,
      variables,
      fetchPolicy: 'network-only',
    });
    return result.data.update_chat_messages_by_pk;
  } catch (error) {
    throw Error(error);
  }
}
